import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { environment } from 'src/environments/environment';
import { Observable, catchError } from 'rxjs';
import { ConfigErrorHandler } from 'src/app/shared/config.errorhandler';
import { ApiResponse } from 'src/app/models/IApiResponse'

@Injectable({
  providedIn: 'root'
})
export class DeliveryNotesService {

  private baseURL = environment.apiURL;

  private headers = new HttpHeaders({ 'Content-Type': 'application/json','Accept': 'application/json' });

  constructor(private httpClient: HttpClient, private errorHandler: ConfigErrorHandler) { }

  /**
   * View delivery notes
   * @returns Array
   */
  getDeliveryNotes(): Observable<ApiResponse>{

    let apiURL:string=`${this.baseURL}/v1/delivery-notes`;

    return this.httpClient.get<ApiResponse>(apiURL,{ headers: this.headers }).pipe(catchError(this.errorHandler.handleError));
  }

  /**
   * Get delivery note info
   * @param delivery_id
   */
  getDeliveryInfo(delivery_uuid: string){

    let apiURL:string=`${this.baseURL}/v1/delivery-note-info/${delivery_uuid}`;

    return this.httpClient.get(apiURL,{ headers: this.headers }).pipe(catchError(this.errorHandler.handleError));
  }

   /**
   * Get delivery note items
   * @param delivery_id
   * @returns Array
   */
   getDeliveryNoteItems(delivery_uuid: string): Observable<ApiResponse>{

    let apiURL:string=`${this.baseURL}/v1/delivery-note-items/${delivery_uuid}`;

    return this.httpClient.get<ApiResponse>(apiURL,{ headers: this.headers }).pipe(catchError(this.errorHandler.handleError));
  }

  /**
   * Get customer info
   * @param delivery_id
   */
  getCustomerInfo(id: string){

    let apiURL:string=`${this.baseURL}/v1/delivery-note/get-customer-info/${id}`;

    return this.httpClient.get(apiURL,{ headers: this.headers }).pipe(catchError(this.errorHandler.handleError));
  }

  /**
   * Edit customer info
   * @param customerName
   * @param customerAddress
   * @returns array
   */
  updateCustomerInfo(customerName:string,idNo:string,phoneNo:string,customerAddress:string,id: string):Observable<any>{

    const formData = {
      customer_name: customerName,
      id_no:idNo,
      phone_no:phoneNo,
      customer_address: customerAddress
    };

    let apiURL:string=`${this.baseURL}/v1/delivery-note/update-customer-info/${id}`;

    return this.httpClient.put(apiURL,formData, { headers: this.headers }).pipe(catchError(this.errorHandler.handleError));
  }

  /**
   * Upload signed delivery note
   */
  uploadSignedDeliveryNote(delivery_id: string,vehicle_id:string,signed_delivery_note_attachment:any):Observable<any>{
    const formData = new FormData();
    formData.append("delivery_id", delivery_id);
    formData.append("vehicle_id", vehicle_id);
    formData.append('attachment', signed_delivery_note_attachment);

    let apiURL:string=`${this.baseURL}/v1/delivery-notes/upload-signed-copy`;

    return this.httpClient.post(apiURL,formData).pipe(catchError(this.errorHandler.handleError));
  }

  /**
   * Get sales reps
   * @returns Array
   */
  getSalesReps(): Observable<ApiResponse>{

    let apiURL:string=`${this.baseURL}/v1/crm/get-sales-reps`;

    return this.httpClient.get<ApiResponse>(apiURL).pipe(catchError(this.errorHandler.handleError));
  }

  /**
   * Associate sales rep. with the sale
   * @param formData
   * @returns array
   */
  addSalesRep(delivery_noted_id: string, sales_rep_id:string):Observable<any>{

    let apiURL:string=`${this.baseURL}/v1/delivery-notes/add-sales-rep`;

     const data = {
      delivery_noted_id:delivery_noted_id,
      sales_rep_id:sales_rep_id,
    };

    return this.httpClient.post(apiURL,data, { headers: this.headers }).pipe(catchError(this.errorHandler.handleError));
  }
}
